import React from "react";
import { useNavigate } from "react-router-dom";
import CardLoading from "../../../components/CardLoading";
import { useSelector } from "react-redux";

const items = [
  {
    title: "Expressed interests",
    total: "0",
    link:'/farmer/expression-of-interest'
  },
  {
    title: "Installed",
    total: "1",
  },
  {
    title: "Loans",
    total: "0",
  },
  {
    title: "MISPS",
    total: "0",
  },
  {
    title: "Cummulative Bal",
    total: "0",
  },
];

function CardFarmer() {
  const urlFarmer = "api/v2/flid/dashboard/mainParams";
  const navigate = useNavigate();
  const { loading, dataCard } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCard: state.fetch.data[urlFarmer] || [],   
  }));
  console.log("dataCard",dataCard)
  if (loading ) return <CardLoading />;
  return (
    <div className="mt-[1.75rem]">
      <div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
        {items &&
          items?.map((item) => (
            <div
              key={item?.total}
              style={{
                borderRadius: "0.75rem",
                background: "#FFF",
                boxShadow: "0px 4px 20px 0px rgba(7, 6, 18, 0.10)",
              }}
              className="p-[1.25rem] border border-[#D6E1F5] lg:w-[280px] w-full cursor-pointer"
              onClick={() => item?.link && navigate(item?.link)} 
            >
              <div className="dash-card-h1 ">{item?.title}</div>
              <div className=" dash-card-h1  !text-[1.5rem] !font-[500] !text-[#0092CC]  mt-[1.62rem]">
                {item?.total} 
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default CardFarmer;
